import DiscoverMandatesResult from './DiscoverMandatesResult'

export default DiscoverMandatesResult
